import React from "react";
import ProcessFeeOptionSelect from "./ProcessFeeOptionSelect";
import { ProcessFeeOption } from "../../apis/models/ProcessFeeDetailsResponse";
import { ProcessFeeOptionRequestItem } from "../../apis/models/ProcessFeeRequest";

const ProcessFeeOptionSelectCell: React.FC<ProcessFeeOptionSelectCellProps> = (props: ProcessFeeOptionSelectCellProps) => {
  return (
    <div>
      {
        props.isConfirmed ? (
          <span>{props.value}</span>
        ) : (
          <ProcessFeeOptionSelect
            options={props.options}
            onSelect={(value) => props.onSelect(value)}
            onAddOption={(value) => props.onAddOption(value)}
            errorMessage={props.error}
            defaultValue={props.value}
          />
        )
      }
    </div>
  )
}

export default ProcessFeeOptionSelectCell;

export type ProcessFeeOptionSelectCellProps = {
  options: ProcessFeeOption[];
  onSelect: (value: ProcessFeeOption | undefined) => void;
  onAddOption: (option: ProcessFeeOptionRequestItem) => void;
  error: string | undefined;
  isConfirmed: boolean;
  value: string;
}
